import type {ReactElement} from 'react';
import {CircularProgressLoader, LOADER_SIZE} from '@Components/circular-progress-loader';
import {useAppSelector} from '@/hooks';
import type {PageContentLoadingPillProps} from './page-content-loading-pill.types';
import styles from './page-content-loading-pill.module.scss';

export function PageContentLoadingPill({pageId}: PageContentLoadingPillProps): ReactElement | null {
  const isDeferredContentLoading = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages?.pagesHashMap?.[pageId]?.isDeferredContentLoading ?? false;
  });

  if (!isDeferredContentLoading) {
    return null;
  }

  return (
    <div className={styles.pill}>
      <CircularProgressLoader size={LOADER_SIZE.XSMALL} />
    </div>
  );
}
